import type { Deliverable } from "@/lib/types";

export const DELIVERABLES: Deliverable[] = [
{
    id: "1",
  name: "Positioning and messaging doc (final)",
  owner: "Jason",
  writerSupport: "Megan",
  approvals: "Stephen",
  phase: "Alpha+",
  due: "May 4",
  status: "not_started",
  category: "messaging",
  dependencies: "Alpha+ learnings",
  notes: "One story. No side versions.",
},
{
    id: "2",
  name: "Competitive positioning guide (vs ISA, AI callers, CRM bolt-ons)",
  owner: "Jason",
  writerSupport: "Megan",
  approvals: "Stephen",
  phase: "Alpha+",
  due: "May 4",
  status: "not_started",
  category: "messaging",
  notes: "Felix vs. specific competitors",
},
{
    id: "3",
  name: "One-line story approved and distributed",
  owner: "Jason",
  writerSupport: "Megan",
  approvals: "Stephen",
  phase: "Alpha+",
  due: "Apr 21",
  status: "in_progress",
  category: "messaging",
  dependencies: "Messaging doc",
  notes: "\"Fello finds it. Felix works it. Your team closes it.\"",
},
{
    id: "4",
  name: "Discovery questions for Sales + CS",
  owner: "Jason",
  writerSupport: "Kerry",
  phase: "Alpha+",
  due: "May 4",
  status: "not_started",
  category: "messaging",
  dependencies: "Messaging doc",
  notes: "Qualifying questions to identify Felix-fit accounts. ISA spend, follow-up gaps, tool stack.",
},
{
    id: "5",
  name: "Target ICP use cases doc",
  owner: "Jason",
  writerSupport: "Megan",
  phase: "Alpha+",
  due: "May 4",
  status: "not_started",
  category: "messaging",
  dependencies: "Messaging doc",
  notes: "Specific use cases by segment (Mega vs Large vs Med)",
},
{
    id: "6",
  name: "FAQ (Sales + CS)",
  owner: "Jason",
  writerSupport: "Megan",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "messaging",
  dependencies: "Messaging, competitive",
  notes: "Cover AI trust, pricing, data, compliance, augmentation vs replacement",
},
{
    id: "7",
  name: "Pricing & packaging framework (final)",
  owner: "Stephen",
  writerSupport: "Dustin / Tom / Kerry / Courtney",
  approvals: "ELT",
  phase: "Closed Beta",
  due: "May 22",
  status: "not_started",
  category: "pricing",
  flag: "Longest pole. Blocks pricing page, ROI calc, sequences, expansion playbook.",
  dependencies: "Product/Eng cost estimate, customer calls (Alpha+), internal XFN alignment",
  notes: "AMENDED: Do not mark complete until pricing governance (#7.1) is defined and owned.",
},
{
    id: "7.1",
  name: "[NEW] Pricing governance: post-launch ownership, approval thresholds, change communication",
  owner: "Rick",
  approvals: "Stephen",
  phase: "GA",
  due: "Jun 22",
  status: "not_started",
  category: "pricing",
  dependencies: "Pricing framework (#7.0)",
  notes: "Who owns pricing changes post-launch, approval thresholds, how updates communicated to Sales. Dependency for #7.0 completion.",
},
{
    id: "11",
  name: "ROI calculator / comp pricing tool",
  owner: "Jason",
  writerSupport: "Megan",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "pricing",
  dependencies: "Final pricing",
  notes: "Sales tool to show Felix ROI vs ISA/current costs",
},
{
    id: "12",
  name: "First-meeting deck rebuild (Felix at core)",
  owner: "Stephen",
  writerSupport: "Seth / Megan / Jason",
  approvals: "Kerry / Dustin",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "enablement",
  dependencies: "Messaging doc",
  notes: "Seth designs",
},
{
    id: "13",
  name: "Sales one-pagers",
  owner: "Jason",
  writerSupport: "Megan",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "enablement",
  dependencies: "Messaging doc",
},
{
    id: "14",
  name: "Pre-demo and post-demo sequences",
  owner: "Jason",
  writerSupport: "Megan",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "enablement",
  dependencies: "Messaging, demo video",
},
{
    id: "15",
  name: "Sequences for existing customers (expansion)",
  owner: "Jason",
  writerSupport: "Megan",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "enablement",
  dependencies: "Pricing framework",
  notes: "Expansion motion",
},
{
    id: "16",
  name: "Objection handling guide",
  owner: "Jason",
  writerSupport: "Megan",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "enablement",
  dependencies: "Competitive guide",
  notes: "AI trust, compliance, augmentation vs replacement",
},
{
    id: "17",
  name: "Sales demo talk track",
  owner: "Kerry",
  writerSupport: "Jason",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "enablement",
  dependencies: "Demo approach",
  notes: "Separate talk track for consistency",
},
{
    id: "18",
  name: "CS talk track",
  owner: "Courtney",
  writerSupport: "Jason",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "enablement",
  dependencies: "Messaging doc",
  notes: "CS needs its own version",
},
{
    id: "19",
  name: "Sales enablement session",
  owner: "Olivia",
  writerSupport: "Jason / Megan",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "enablement",
  dependencies: "All sales materials",
},
{
    id: "20",
  name: "Update sales playbook (HubSpot)",
  owner: "Kerry",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "enablement",
  dependencies: "Enablement session, opp stage redesign (#20.1), upsell tracking (#20.2)",
  notes: "Final consolidation step once #20.1 and #20.2 are complete",
},
{
    id: "20.1",
  name: "[NEW] Opportunity stage redesign for Felix deal motion",
  owner: "Rick",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "enablement",
  dependencies: "Messaging doc, pricing framework",
  notes: "Define new stages reflecting longer, more complex sales cycle. Must precede #20.0.",
},
{
    id: "20.2",
  name: "[NEW] Upsell ARR tracking setup in HubSpot",
  owner: "Rick",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "enablement",
  dependencies: "Opp stage redesign (#20.1)",
  notes: "Separate pipeline and reporting for expansion vs new-business ARR. Distinct from #20.0.",
},
{
    id: "21",
  name: "Demo approach defined (live vs snapshot vs hybrid)",
  owner: "Jason",
  writerSupport: "Kerry / Ryan",
  approvals: "Stephen",
  phase: "Alpha+",
  due: "May 4",
  status: "not_started",
  category: "demo",
  dependencies: "Product readiness",
  notes: "Safe boundaries, standard talk track",
},
{
    id: "22",
  name: "Demo video (branded, explainer)",
  owner: "Jason",
  writerSupport: "Seth / PM",
  approvals: "Stephen",
  phase: "Closed Beta",
  due: "May 17",
  status: "not_started",
  category: "demo",
  dependencies: "Demo approach",
},
{
    id: "23",
  name: "Sizzle reel",
  owner: "Jason",
  writerSupport: "Seth / Megan",
  approvals: "Stephen",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "demo",
},
{
    id: "24",
  name: "Instructional / training videos",
  owner: "Jason",
  writerSupport: "PM",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "demo",
  dependencies: "Working product",
  notes: "How-to for onboarding. Separate from explainer.",
},
{
    id: "25",
  name: "Case study #1",
  owner: "Jason",
  writerSupport: "Megan",
  phase: "Open Beta",
  due: "Jun 8",
  status: "not_started",
  category: "demo",
  dependencies: "Beta customer approval",
  notes: "Video where possible",
},
{
    id: "26",
  name: "Case study #2",
  owner: "Jason",
  writerSupport: "Megan",
  phase: "GA",
  due: "Jun 22",
  status: "not_started",
  category: "demo",
  dependencies: "Beta customer approval",
},
{
    id: "27",
  name: "Proof capture plan (quotes, before/after)",
  owner: "Jason",
  writerSupport: "Megan",
  phase: "Alpha+",
  due: "May 4",
  status: "not_started",
  category: "demo",
  dependencies: "Beta cohort identified",
  notes: "Start collecting from Alpha+",
},
{
    id: "28",
  name: "Customer interview program",
  owner: "Jason",
  writerSupport: "CS",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "demo",
  dependencies: "Beta accounts live",
  notes: "PMF survey, open feedback, interviews, usage data",
},
{
    id: "29",
  name: "Felix teaser landing page (coming soon + email capture)",
  owner: "Seth",
  writerSupport: "Jason / Megan",
  approvals: "Stephen",
  phase: "Alpha+",
  due: "Apr 27",
  status: "in_progress",
  category: "design",
  dependencies: "One-line story approved",
  notes: "Live on fello.com when teasers start",
},
{
    id: "30",
  name: "Visual asset kit (screenshots, hero images, social graphics)",
  owner: "Seth",
  writerSupport: "Jason",
  approvals: "Stephen",
  phase: "Closed Beta",
  due: "May 14",
  status: "not_started",
  category: "design",
  dependencies: "Working product, messaging",
  notes: "Consistent visual language across all surfaces",
},
{
    id: "31",
  name: "Full Felix webpage (dedicated product page)",
  owner: "Seth",
  writerSupport: "Jason / Megan",
  approvals: "Stephen",
  phase: "Closed Beta",
  due: "May 17",
  status: "not_started",
  category: "design",
  dependencies: "Messaging, design, demo video",
  notes: "Replaces teaser LP. Full product page.",
},
{
    id: "32",
  name: "Webinar landing pages (beta + open beta)",
  owner: "Seth",
  writerSupport: "Lisa",
  phase: "Alpha+",
  due: "May 1",
  status: "not_started",
  category: "design",
  dependencies: "Webinar details confirmed",
  notes: "Dedicated LPs for each webinar",
},
{
    id: "33",
  name: "Website refresh — homepage",
  owner: "Seth",
  writerSupport: "Jason / Megan",
  approvals: "Stephen",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "design",
  dependencies: "Felix webpage, messaging",
  notes: "Reframe whole site around AIOS. Felix is core, not a bolt-on.",
},
{
    id: "34",
  name: "Website refresh — product pages",
  owner: "Seth",
  writerSupport: "Jason / Megan",
  approvals: "Stephen",
  phase: "Open Beta",
  due: "Jun 8",
  status: "not_started",
  category: "design",
  dependencies: "Homepage refresh",
  notes: "Living Database, Felix, Workspace, Copilot pages updated",
},
{
    id: "35",
  name: "Website refresh — pricing page",
  owner: "Seth",
  writerSupport: "Jason / Megan",
  approvals: "Stephen / ELT",
  phase: "GA",
  due: "Jun 22",
  status: "not_started",
  category: "design",
  flag: "Cannot publish until pricing locked. If pricing slips, this slips.",
  dependencies: "Pricing framework finalized",
},
{
    id: "36",
  name: "Social teaser content calendar (Fello brand)",
  owner: "Ryan",
  writerSupport: "Lisa",
  phase: "Alpha+",
  due: "Apr 27",
  status: "not_started",
  category: "marketing",
  notes: "Ryan leads social, Lisa supports",
},
{
    id: "37",
  name: "Felix social profiles + content calendar",
  owner: "Nikhil",
  writerSupport: "Lisa / Jason",
  approvals: "Stephen",
  phase: "Alpha+",
  due: "Apr 27",
  status: "not_started",
  category: "marketing",
  dependencies: "Felix voice/brand approved",
  notes: "Felix as social personality. LinkedIn + X. Nikhil makes it agentic.",
},
{
    id: "38",
  name: "Beta webinar (May 4)",
  owner: "Ryan",
  writerSupport: "Lisa / Sanjoy",
  phase: "Alpha+",
  due: "May 4",
  status: "not_started",
  category: "marketing",
  dependencies: "Beta accounts confirmed, Twilio approved",
  notes: "Lisa helps with marketing/logistics",
},
{
    id: "39",
  name: "Community hype videos (problem-solution format)",
  owner: "Jamie",
  writerSupport: "Marketing",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "marketing",
  dependencies: "Beta customer participation",
  notes: "Short videos, beta customers sharing early reactions",
},
{
    id: "40",
  name: "Email campaign to prospects + customers",
  owner: "Lisa",
  writerSupport: "Jason / Megan / Nikhil",
  phase: "Closed Beta",
  due: "May 17",
  status: "not_started",
  category: "marketing",
  dependencies: "Messaging, webpage",
  notes: "Nikhil co-owns for agentic execution",
},
{
    id: "41",
  name: "Partner & affiliate communications kit",
  owner: "Lisa",
  writerSupport: "Jason / Megan",
  phase: "Closed Beta",
  due: "May 17",
  status: "not_started",
  category: "marketing",
  dependencies: "Messaging doc",
  notes: "Partner email, co-marketing assets, blog for partner communities",
},
{
    id: "42",
  name: "Podcast booking list + talking points for Ryan",
  owner: "Lisa",
  writerSupport: "Jason / Megan",
  phase: "Closed Beta",
  due: "May 17",
  status: "not_started",
  category: "marketing",
  dependencies: "Messaging doc",
  notes: "Target 10+ RE/AI podcasts. Book 3–4 by May 17.",
},
{
    id: "43",
  name: "Felix \"applying for jobs\" campaign",
  owner: "Lisa",
  writerSupport: "Nikhil / Jason",
  approvals: "Stephen / Legal",
  phase: "Closed Beta",
  due: "May 19",
  status: "not_started",
  category: "marketing",
  dependencies: "Felix social profiles, legal review",
  notes: "Felix applies to ISA job postings. Cheeky, shareable.",
},
{
    id: "44",
  name: "Teaser ads + landing page",
  owner: "Lisa",
  writerSupport: "Seth / Megan",
  approvals: "Stephen",
  phase: "Closed Beta",
  due: "May 17",
  status: "not_started",
  category: "marketing",
  dependencies: "Messaging, webpage",
},
{
    id: "45",
  name: "Open Beta webinar (Jun 1)",
  owner: "Lisa",
  writerSupport: "Jason",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "marketing",
  dependencies: "Beta results, case study",
  notes: "Include beta customers as speakers",
},
{
    id: "46",
  name: "Ads / paid media launch",
  owner: "Lisa",
  writerSupport: "Nikhil",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "marketing",
  dependencies: "Landing page, webinar",
},
{
    id: "47",
  name: "Felix \"Day in the Life\" content series",
  owner: "Jason",
  writerSupport: "Megan / Nikhil",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "marketing",
  dependencies: "Beta account data (anonymized)",
  notes: "Serialized content showing what Felix does hour by hour",
},
{
    id: "48",
  name: "Agentic Felix outreach to engaged prospects",
  owner: "Nikhil",
  writerSupport: "Lisa / Jason",
  approvals: "Stephen / Legal",
  phase: "Open Beta",
  due: "Jun 8",
  status: "not_started",
  category: "marketing",
  dependencies: "Marketing automation, compliance",
  notes: "Felix reaches out to engaged prospects as himself. Product IS the marketing.",
},
{
    id: "49",
  name: "Blog post",
  owner: "Jason",
  writerSupport: "Megan",
  phase: "GA",
  due: "Jun 22",
  status: "not_started",
  category: "marketing",
},
{
    id: "50",
  name: "Press release (go/no-go decided in Closed Beta II)",
  owner: "Stephen",
  writerSupport: "Jason / Megan",
  approvals: "ELT",
  phase: "GA",
  due: "Jun 22",
  status: "not_started",
  category: "marketing",
  dependencies: "Decision happens during Closed Beta II window",
  notes: "Decide mid-beta. If yes, execute in June.",
},
{
    id: "51",
  name: "In-app messages",
  owner: "PM",
  writerSupport: "Jason",
  phase: "Open Beta",
  due: "Jun 8",
  status: "not_started",
  category: "marketing",
},
{
    id: "52",
  name: "Customer operating playbook",
  owner: "Courtney",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "cs",
  dependencies: "Alpha+ learnings",
  notes: "Prevent Felix blame for exposing operational weakness",
},
{
    id: "53",
  name: "CS onboarding playbook v1",
  owner: "Courtney",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "cs",
  dependencies: "Beta learnings, A/B test results",
  notes: "A/B test determines high-touch vs self-serve model",
},
{
    id: "54",
  name: "CS capacity plan for Open Beta",
  owner: "Courtney / Dustin",
  phase: "Closed Beta",
  due: "Jun 2",
  status: "not_started",
  category: "cs",
  flag: "20 accts/week target. If high-touch wins, need headcount confirmation.",
  dependencies: "A/B test results",
},
{
    id: "55",
  name: "CS expansion playbook (early access → paid)",
  owner: "Courtney",
  writerSupport: "Jason",
  phase: "Open Beta",
  due: "Jun 8",
  status: "not_started",
  category: "cs",
  dependencies: "Pricing framework, QBR cadence (#55.1), health scoring (#55.2), escalation path (#55.3)",
  notes: "QBR, health scoring, and escalation items feed into this playbook as inputs.",
},
{
    id: "55.1",
  name: "[NEW] QBR cadence definition and templates for Felix customers",
  owner: "Courtney",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "cs",
  dependencies: "CS onboarding playbook",
  notes: "Define cadence, agenda template, success metrics for Felix QBRs.",
},
{
    id: "55.2",
  name: "[NEW] Customer health scoring methodology for Felix accounts",
  owner: "Courtney",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "cs",
  dependencies: "TTV metrics, FIR tracking",
  notes: "What signals indicate healthy vs at-risk Felix accounts.",
},
{
    id: "55.3",
  name: "[NEW] CS-to-support escalation path definition",
  owner: "Courtney",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "cs",
  notes: "Specific handoff between CS and support organizations. Must be defined before beta.",
},
{
    id: "55.4",
  name: "[NEW] Post-GA CS staffing plan",
  owner: "Courtney",
  phase: "GA",
  due: "Jun 22",
  status: "not_started",
  category: "cs",
  dependencies: "CS capacity plan (#54.0), beta learnings",
  notes: "Separate from #54.0 which is scoped to Open Beta only. This covers ongoing headcount.",
},
{
    id: "55.5",
  name: "[NEW] Hiring plan for sales roles to support new deal motion",
  owner: "Courtney",
  writerSupport: "Rick",
  phase: "Open Beta",
  due: "Jun 8",
  status: "not_started",
  category: "cs",
  dependencies: "Pipeline/forecasting design",
  notes: "Net-new roles needed for Felix deal motion.",
},
{
    id: "56",
  name: "Help articles / knowledge base",
  owner: "PM",
  writerSupport: "Support",
  phase: "Open Beta",
  due: "Jun 8",
  status: "not_started",
  category: "cs",
  notes: "AMENDED: Scope = customer-facing docs only. SLA definition and ticket taxonomy covered in Customer Support Readiness section.",
},
{
    id: "57",
  name: "Set up tracking / KPIs dashboard (FIR)",
  owner: "Rick",
  writerSupport: "PM",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "systems",
  notes: "Mixpanel, HubSpot, Gong. FIR must be trackable.",
},
{
    id: "58",
  name: "Create Gong trackers + initiative board",
  owner: "Rick",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "systems",
  notes: "Track Felix mentions in calls, competitive mentions, objections",
},
{
    id: "59",
  name: "Create automations for CS target lists",
  owner: "Rick",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "systems",
  dependencies: "Beta learnings",
  notes: "Automated lists for CS to identify Felix-fit accounts",
},
{
    id: "60",
  name: "Internal launch announcement (GChat, all-hands)",
  owner: "Rick",
  phase: "GA",
  due: "Jun 22",
  status: "not_started",
  category: "systems",
  notes: "Formal internal comms",
},
{
    id: "75",
  name: "Google Chat launch tracker (agentic manager)",
  owner: "Rick",
  writerSupport: "Nikhil / PM",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "systems",
  dependencies: "Dashboard live, deliverables assigned",
  notes: "Automated updates to Google Chat.",
},
{
    id: "57.1",
  name: "[NEW] CRM data architecture: new fields, objects, product lines for Felix deals",
  owner: "Rick",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "systems",
  flag: "Must be completed before first deal closes.",
  notes: "New fields/objects needed to track Felix deals separately from Fello.",
},
{
    id: "57.2",
  name: "[NEW] Systems access and permissions provisioning plan for new hires",
  owner: "Rick",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "systems",
  dependencies: "Hiring plan",
  notes: "Ensure new hires have CRM, Gong, tools access from day one.",
},
{
    id: "57.3",
  name: "[NEW] Close-to-onboarding handoff process",
  owner: "Rick",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "systems",
  dependencies: "CRM architecture (#57.1)",
  notes: "What transfers from Sales to CS at deal close. Who owns it. CS pickup SLA.",
},
{
    id: "61",
  name: "Training deck",
  owner: "Olivia",
  writerSupport: "Jason",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "enablement",
  dependencies: "All materials",
},
{
    id: "62",
  name: "Train managers (Sales + CS)",
  owner: "Olivia",
  writerSupport: "Jason",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "enablement",
  dependencies: "Training deck",
  notes: "Managers first, then reps",
},
{
    id: "63",
  name: "Train Sales team",
  owner: "Olivia",
  writerSupport: "Jason",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "enablement",
  dependencies: "Training deck",
},
{
    id: "64",
  name: "Train CS team",
  owner: "Olivia",
  writerSupport: "Jason",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "enablement",
  dependencies: "Training deck",
},
{
    id: "65",
  name: "Train Solutions Engineering",
  owner: "Olivia",
  writerSupport: "Jason",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "enablement",
  dependencies: "Training deck",
},
{
    id: "66",
  name: "Knowledge check / certification",
  owner: "Olivia",
  phase: "Open Beta",
  due: "Jun 8",
  status: "not_started",
  category: "enablement",
  dependencies: "Training complete",
  notes: "Validates readiness before Open Beta ramp",
},
{
    id: "67",
  name: "Reinforcement plan (30/60/90)",
  owner: "Olivia",
  writerSupport: "Jason",
  phase: "GA",
  due: "Jun 22",
  status: "not_started",
  category: "enablement",
  dependencies: "Training complete",
  notes: "Prevents knowledge decay",
},
{
    id: "67.1",
  name: "[NEW] Support team enablement on Felix",
  owner: "PD",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "enablement",
  dependencies: "Training deck, support readiness section",
  notes: "Support team needs Felix product training equivalent to Sales/CS. Currently absent.",
},
{
    id: "80",
  name: "[NEW] Assess billing infrastructure for new pricing model",
  owner: "Rick",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "billing",
  dependencies: "Pricing framework (#7.0)",
  notes: "Can existing billing support Felix? Procure upgrade if required.",
},
{
    id: "80.1",
  name: "[NEW] Build upsell provisioning flows",
  owner: "Rick",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "billing",
  dependencies: "Billing assessment (#80.0)",
  notes: "When existing customer adds Felix: entitlement activated, billed correctly, reflected in CRM.",
},
{
    id: "80.2",
  name: "[NEW] Define invoice/payment/contract billing workflows for higher-ACV deals",
  owner: "Rick",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "billing",
  dependencies: "Pricing framework",
  notes: "Net terms, PO support, ACH/wire for larger deals.",
},
{
    id: "80.3",
  name: "[NEW] Revenue recognition and billing reconciliation with finance",
  owner: "Rick",
  phase: "GA",
  due: "Jun 22",
  status: "not_started",
  category: "billing",
  dependencies: "Billing workflows (#80.2)",
  notes: "Rev rec processes aligned with finance.",
},
{
    id: "81",
  name: "[NEW] Define upgrade from click-through to formal deal execution process",
  owner: "Rick",
  approvals: "Legal",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "deal_exec",
  dependencies: "Pricing framework",
  notes: "For higher-ACV contracts. Define threshold for formal vs click-through.",
},
{
    id: "81.1",
  name: "[NEW] Develop MSA and/or order form template for larger deals",
  owner: "Rick",
  approvals: "Legal",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "deal_exec",
  flag: "Legal has no owner/approver/dependency in tracker — needs to be added.",
  notes: "NOTE: Legal role must be assigned across the launch plan.",
},
{
    id: "81.2",
  name: "[NEW] Build or configure CPQ/quoting capability",
  owner: "Rick",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "deal_exec",
  dependencies: "Pricing framework, MSA template (#81.1)",
  notes: "Sales can generate consistent, accurate proposals.",
},
{
    id: "81.3",
  name: "[NEW] Define deal threshold: formal process vs click-through",
  owner: "Rick",
  approvals: "ELT",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "deal_exec",
  dependencies: "Pricing framework",
  notes: "At what ACV does a deal require the formal execution path?",
},
{
    id: "81.4",
  name: "[NEW] Contract lifecycle management process",
  owner: "Rick",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "deal_exec",
  flag: "Must be in place before first contract closes.",
  notes: "Storage, renewal date tracking, auto-renew visibility for MSA-based contracts.",
},
{
    id: "82",
  name: "[NEW] Design revised sales compensation plan for new deal motion",
  owner: "Rick",
  approvals: "ELT",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "people_comp",
  dependencies: "Pricing framework, opp stage redesign (#20.1)",
  notes: "Quota structure, accelerators, split credit rules.",
},
{
    id: "82.1",
  name: "[NEW] Comp plan approval and communication to sales team",
  owner: "Rick",
  approvals: "ELT",
  phase: "Open Beta",
  due: "Jun 8",
  status: "not_started",
  category: "people_comp",
  dependencies: "Comp plan design (#82.0)",
  notes: "Must be communicated before new motion goes live.",
},
{
    id: "82.2",
  name: "[NEW] Update commission tracking and payout infrastructure",
  owner: "Rick",
  phase: "Open Beta",
  due: "Jun 8",
  status: "not_started",
  category: "people_comp",
  dependencies: "Comp plan (#82.0)",
  notes: "Reflect new deal complexity.",
},
{
    id: "82.3",
  name: "[NEW] Build comp attainment reporting for reps and managers",
  owner: "Rick",
  phase: "GA",
  due: "Jun 22",
  status: "not_started",
  category: "people_comp",
  dependencies: "Commission tracking (#82.2)",
  notes: "Reps and managers can see attainment.",
},
{
    id: "82.4",
  name: "[NEW] Develop hiring plan for sales roles",
  owner: "Rick",
  phase: "Open Beta",
  due: "Jun 8",
  status: "not_started",
  category: "people_comp",
  dependencies: "Pipeline/forecasting design",
  notes: "Headcount needed to support new motion.",
},
{
    id: "82.5",
  name: "[NEW] Define reskilling plan for CS to support higher-ACV customers",
  owner: "Rick",
  writerSupport: "Courtney",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "people_comp",
  dependencies: "CS expansion playbook (#55.0)",
  notes: "CS team capability gaps for higher-touch, higher-ACV.",
},
{
    id: "82.6",
  name: "[NEW] Define ongoing CS success model: QBR cadence, health scoring, escalation paths",
  owner: "Rick",
  writerSupport: "Courtney",
  phase: "GA",
  due: "Jun 22",
  status: "not_started",
  category: "people_comp",
  dependencies: "QBR (#55.1), health scoring (#55.2), escalation (#55.3)",
  notes: "Consolidation of CS success infrastructure.",
},
{
    id: "83",
  name: "[NEW] Design sales forecasting methodology and cadence for Felix",
  owner: "Rick",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "pipeline_ops",
  dependencies: "Opp stage redesign (#20.1)",
  notes: "Account for new deal cycle length and ACV range.",
},
{
    id: "83.1",
  name: "[NEW] Define territory and account segmentation for Felix",
  owner: "Rick",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "pipeline_ops",
  dependencies: "ICP use cases (#5.0)",
  notes: "Who owns Med+ teams in existing base for upsell vs net new.",
},
{
    id: "83.2",
  name: "[NEW] Define lead routing logic and follow-up SLAs for new ICP",
  owner: "Rick",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "pipeline_ops",
  dependencies: "Territory segmentation (#83.1)",
  notes: "Routing rules and response time commitments.",
},
{
    id: "83.3",
  name: "[NEW] Define renewal and expansion motion",
  owner: "Rick",
  writerSupport: "Courtney",
  phase: "GA",
  due: "Jun 22",
  status: "not_started",
  category: "pipeline_ops",
  dependencies: "CS expansion playbook (#55.0), pricing",
  notes: "Who owns it, what triggers it, what the process looks like.",
},
{
    id: "83.4",
  name: "[NEW] Establish partner and referral attribution tracking",
  owner: "Rick",
  phase: "GA",
  due: "Jun 22",
  status: "not_started",
  category: "pipeline_ops",
  dependencies: "Partner kit (#41.0)",
  notes: "If partner kit generates inbound deals, track attribution.",
},
{
    id: "84",
  name: "[NEW] Define Felix-specific ticket taxonomy and categories",
  owner: "Rick",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "cs",
  notes: "Existing categories won't map to new product issues. Must be in place before launch.",
},
{
    id: "84.1",
  name: "[NEW] Define SLA tiers for Felix customers by contract level",
  owner: "Rick",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "cs",
  dependencies: "Pricing framework, deal threshold (#81.3)",
  notes: "Higher-ACV = higher response/resolution expectations.",
},
{
    id: "84.2",
  name: "[NEW] Assess support staffing and capacity",
  owner: "Rick",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "cs",
  dependencies: "Beta learnings",
  notes: "Project ticket volume at launch. Confirm team is sized appropriately.",
},
{
    id: "84.3",
  name: "[NEW] Define escalation paths (support → product/eng/CS)",
  owner: "Rick",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "cs",
  dependencies: "CS-to-support escalation (#55.3)",
  notes: "When ticket exceeds support ability, where does it go? Test path before launch.",
},
{
    id: "84.4",
  name: "[NEW] Audit and update support tooling",
  owner: "Rick",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "cs",
  dependencies: "Ticket taxonomy (#84.0)",
  notes: "Helpdesk can tag, route, report on Felix tickets distinctly.",
},
{
    id: "84.5",
  name: "[NEW] Support enablement plan",
  owner: "Rick",
  writerSupport: "PD",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "cs",
  dependencies: "Training deck, Felix product knowledge",
  notes: "Support team needs product training equivalent to Sales/CS.",
},
{
    id: "84.6",
  name: "[NEW] Launch readiness brief for support",
  owner: "Rick",
  phase: "Open Beta",
  due: "Jun 8",
  status: "not_started",
  category: "cs",
  dependencies: "Known issues from beta",
  notes: "Living doc: known limitations, workarounds, issues in engineering. Prevents noise escalation.",
},
{
    id: "90",
  name: "[NEW] Define outbound coverage model: SDR vs AE vs Felix vs Marketing ownership",
  owner: "Rick",
  writerSupport: "Lisa / Kerry / Nikhil",
  approvals: "Stephen",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "outbound",
  flag: "Critical: prevents crossed streams between SDRs, AEs, and Felix.",
  notes: "Who owns which accounts/segments for outbound. No duplicate touches. Felix, SDRs, AEs, and marketing each have defined lanes.",
},
{
    id: "90.1",
  name: "[NEW] Define Felix outbound sequences: call, text, email cadence for ICP targets",
  owner: "Rick",
  writerSupport: "Nikhil / Jason",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "outbound",
  dependencies: "Coverage model (#90.0), messaging doc",
  notes: "Felix-specific outbound sequences for Med+ ICP. Call → text → email cadence. Personalized to segment.",
},
{
    id: "90.2",
  name: "[NEW] Define LinkedIn outbound strategy and ownership",
  owner: "Rick",
  writerSupport: "Lisa / Kerry",
  phase: "Closed Beta",
  due: "May 17",
  status: "not_started",
  category: "outbound",
  dependencies: "Coverage model (#90.0), Felix social profiles (#37.0)",
  notes: "Who does LinkedIn outreach: AEs, SDRs, Felix social, or marketing? Define sequence, templates, and tracking.",
},
{
    id: "90.3",
  name: "[NEW] Build suppression/deconfliction rules in CRM",
  owner: "Rick",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "outbound",
  dependencies: "CRM architecture (#57.1), coverage model (#90.0)",
  notes: "If Felix is working an account, SDR/AE outbound pauses. If AE has an active opp, Felix pauses. Automated in CRM.",
},
{
    id: "90.4",
  name: "[NEW] Define Felix-to-human handoff SLA for outbound-generated meetings",
  owner: "Rick",
  writerSupport: "Courtney / Kerry",
  phase: "Closed Beta",
  due: "Jun 1",
  status: "not_started",
  category: "outbound",
  dependencies: "Coverage model (#90.0)",
  notes: "When Felix books a meeting via outbound, how fast does the human pick it up? Who gets it? What context transfers?",
},
{
    id: "90.5",
  name: "[NEW] Outbound performance tracking: Felix vs SDR vs AE conversion rates",
  owner: "Rick",
  phase: "Open Beta",
  due: "Jun 8",
  status: "not_started",
  category: "outbound",
  dependencies: "CRM architecture (#57.1), Gong trackers (#58.0)",
  notes: "Compare Felix outbound conversion to human outbound. FIR attribution for outbound-sourced pipeline.",
},
{
    id: "90.6",
  name: "[NEW] Define ICP target list for Felix outbound",
  owner: "Rick",
  writerSupport: "Lisa",
  phase: "Alpha+",
  due: "May 11",
  status: "not_started",
  category: "outbound",
  dependencies: "Territory segmentation (#83.1)",
  notes: "Which accounts does Felix outbound to first? Aligned to canonical target account list from Constitution.",
},
{
    id: "68",
  name: "Launch debrief / retro",
  owner: "Stephen",
  writerSupport: "Jason",
  phase: "GA",
  due: "Jul 13",
  status: "not_started",
  category: "post_launch",
  dependencies: "GA launch",
  notes: "Structured retrospective",
},
{
    id: "69",
  name: "Feedback loop established",
  owner: "Jason",
  writerSupport: "PM",
  phase: "GA",
  due: "Jul 13",
  status: "not_started",
  category: "post_launch",
  notes: "Ongoing feedback mechanism",
},
{
    id: "70",
  name: "30-day messaging check-in",
  owner: "Jason",
  phase: "GA",
  due: "Aug 3",
  status: "not_started",
  category: "post_launch",
  notes: "Are reps using assets? What objections?",
},
{
    id: "71",
  name: "60-day case study target",
  owner: "Jason",
  writerSupport: "Megan",
  phase: "GA",
  due: "Sep 1",
  status: "not_started",
  category: "post_launch",
},
{
    id: "72",
  name: "60-day enablement follow-up",
  owner: "Olivia",
  writerSupport: "Jason",
  phase: "GA",
  due: "Sep 1",
  status: "not_started",
  category: "post_launch",
  dependencies: "30-day check-in",
  notes: "Based on what is/isn't landing",
},
{
    id: "73",
  name: "Augmentation vs replacement language audit",
  owner: "Jason",
  phase: "GA",
  due: "Sep 1",
  status: "not_started",
  category: "post_launch",
  notes: "Does positioning need to evolve?",
},
{
    id: "74",
  name: "Revenue impact analysis (FIR attribution)",
  owner: "Jason",
  writerSupport: "PM",
  phase: "GA",
  due: "Sep 1",
  status: "not_started",
  category: "post_launch",
  notes: "Formal FIR attribution analysis",
},
];
